// extracted by mini-css-extract-plugin
export var filterIncDec = "_bf-0";
export var leftBorder = "_bf-1";
export var rightBorder = "_bf-2";
export var stringInput = "_bf-3";